import React from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import PropTypes from 'prop-types';

export const Banner = ({ boardColor, expanded = true, children }) => {
  return (
    <Container color={boardColor}>
      <BannerLeft>{children}</BannerLeft>
      <TransparentContainer expanded={expanded}>
        <TransparentAreaOne></TransparentAreaOne>
        <TransparentAreaTwo></TransparentAreaTwo>
        <TransparentAreaThree></TransparentAreaThree>
      </TransparentContainer>
    </Container>
  );
};

Banner.propTypes = {
  boardColor: PropTypes.string,
  expanded: PropTypes.bool,
  children: PropTypes.node,
};

const BannerLeft = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 0 28px 28px 28px;
  z-index: 1;

  ${themeGet('mediaQueries.forLargeUp')} {
    width: 55%;
    padding: 25px 0px 25px 59px;
  }
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  border-radius: 8px;
  flex-direction: column-reverse;
  width: auto;
  background: ${props => props.color};
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(37, 40, 43, 0.24);
  width: 100%;

  ${themeGet('mediaQueries.forLargeUp')} {
    flex-direction: row;
  }
`;

const TransparentContainer = styled.div`
  visibility: ${props => (props.expanded ? 'visible' : 'hidden')};
  height: ${props => (props.expanded ? '93px' : '0px')};
  transition: visibility 0.3s, height 0.8s;
  width: 100%;
  position: relative;
  overflow: hidden;
  ${themeGet('mediaQueries.forLargeUp')} {
    visibility: visible;
    height: auto;
    width: 45%;
  }
`;

const TransparentAreaOne = styled.div`
  opacity: 0.6;
  clip-path: polygon(0 0, 100% 0, 100% 24%, 0 14%);
  background-color: ${themeGet('colors.white')};
  display: block;
  width: 100%;
  height: 100%;
  ${themeGet('mediaQueries.forLargeUp')} {
    opacity: 0.2;
    clip-path: polygon(54% 0, 0 100%, 100% 0);
  }
`;
const TransparentAreaTwo = styled.div`
  position: absolute;
  top: 13px;
  width: 100%;
  height: 100%;
  opacity: 0.4;
  background-color: ${themeGet('colors.white')};
  display: block;
  clip-path: polygon(0 0%, 100% 10%, 100% 46%, 0% 20%);
  ${themeGet('mediaQueries.forLargeUp')} {
    top: 0;
    clip-path: polygon(100% 0, 100% 48%, 0 100%, 0 100%);
  }
`;
const TransparentAreaThree = styled.div`
  position: absolute;
  top: 32px;
  width: 100%;
  height: 100%;
  opacity: 0.2;
  background-color: ${themeGet('colors.white')};
  clip-path: polygon(0 0, 100% 26%, 100% 58%, 0 17%);
  display: block;
  ${themeGet('mediaQueries.forLargeUp')} {
    opacity: 0.6;
    top: 0;
    clip-path: polygon(100% 48%, 100% 100%, 0 100%, 0 100%);
  }
`;
